import React, { useContext, useState } from "react";
import { Form, CardBody, FormGroup, Input, Button } from "reactstrap";
import { Redirect, Link } from "react-router-dom"
import { toast } from "react-toastify"
import Axios from "axios";
import { UserContext } from "../../context/UserContext";

const Changepassword = () => {
    const context = useContext(UserContext);
    const [cpass, setCpass] = useState('')
    const [pass, setPass] = useState('')
    const [email, setEmail] = useState(context.user?.otpemail);

    const [issubmited, setSubmit] = useState(false)
    const handleFormSubmit = e => {
        e.preventDefault();
        loggedin();
    }
    const logindata = {
        email: '',
        cpass: '',
    };
    const loggedin = async () => {
		if (pass === "") {
			toast.error("Please Enter Your password ", { position: toast.POSITION.BOTTOM_LEFT });
			return
        }
        if (cpass === "") {
			toast.error("Please Enter Your Confirmation password ", { position: toast.POSITION.BOTTOM_LEFT });
			return
		}
        if (pass !== cpass) {
            toast.error("Passwords and Confirm Password did not match ", { position: toast.POSITION.BOTTOM_LEFT });
        } else {
            logindata.email = email
            logindata.cpass = cpass
            await Axios.post("Login/resetpassword", { logindata })
                .then(res => {
                    if (res.data.status === "200" && res.data.msg === "true") {
                        toast.success("Your Password Change Succesfully ", {
                            position: toast.POSITION.BOTTOM_LEFT,
                        });
                        setSubmit({ issubmited: true });
                        return res
                    }
                    else if (res.data.status === "200" && res.data.message !== "true") {
                        toast.error(res.data.message, { position: toast.POSITION.BOTTOM_LEFT });
                        setPass("");
                        setEmail("");
                        setCpass("");
                        return res
                    }
                    else if (res.data.status) {
                        toast.error("Login-Blocked,Contact Admin", { position: toast.POSITION.BOTTOM_LEFT });
                        setPass("");
                        setEmail("");
                        setCpass("");
                        return res
                    }
                    throw res;
                })
                .catch(error => {
                    console.log("error123", error)
                });
        }
    }
    if (issubmited) {
        return <Redirect to="/Signin" />
    }

    return (
        <div>
            <div class="containers-login">
                <div class="forms-container">
                    <div class="signin-signup">
                        <Form onSubmit={handleFormSubmit} class="sign-in-form">
                            <h2 class="title">Change Password</h2>
                            <CardBody>{this?.props?.location?.state?.email}
                                <Input
                                    type="hidden"
                                    name="emai"
                                    id="emai"
                                    value={email}
                                />
                                <FormGroup row>
                                    <Input className="input-field"
                                        type='password'
                                        name='pass'
                                        id='pass'
                                        value={pass}
                                        onChange={e => setPass(e.target.value)}
                                        placeholder='Enter Password'
                                    />
                                </FormGroup>
                                <FormGroup row>
                                    <Input className="input-field"
                                        type='text'
                                        name='cpass'
                                        id='cpass'
                                        placeholder='Confirm Password'
                                        value={cpass}
                                        onChange={e => setCpass(e.target.value)}
                                    />
                                </FormGroup>
                            </CardBody>
                            <Button type='submit' class="btn transparent">
                                Save
							</Button>
                        </Form>
                    </div>
                </div>
                <div class="panelss-container">
                    <div class="panels left-panels">
                        <div class="content contents " >
                            <h3>Part of Eduplusnow ?</h3>
                            <p>
                                Welcome back to eduplusnow
          					  </p>
                            <Link class="btn transparent" to="/signin"> Sign in</Link>
                        </div>
                        <img src="/assets/images/eduplusnow1.png" alt="eduplusnow_white" class="image" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Changepassword;